import { i18nFilter } from "app/filters/i18nFilter";
import { TrialTextStyled } from "./StyledTrialText";
import { getBannerText } from "app/components/React/TrialBanner/utils/trialBannerHelpers";
import { swSettings } from "app/common/services/swSettings";
import { isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import type { Banner } from "app/components/React/TrialBanner/utils/trialBannerConfig";

const i18n = i18nFilter();

interface ITrialTextProps {
    bannerType: Banner;
    shouldGoToAfterTrial?: boolean;
}

const TrialText = ({ bannerType, shouldGoToAfterTrial }: ITrialTextProps) => {
    const text = getBannerText(bannerType, i18n, swSettings);
    if (!text) {
        return null;
    }
    const isTrialUser = isTrial(swSettings);

    return (
        <TrialTextStyled
            isUserWithoutTrial={shouldGoToAfterTrial}
            isBoldText={isTrialUser}
        >
            <span dangerouslySetInnerHTML={{ __html: text }} />
        </TrialTextStyled>
    );
};

export default TrialText;
